<template>
  <div>
    <answer-header></answer-header>
    <img class="logo" src="../assets/logo.png">
    <div class="blk2 fz32">
      <p>
        {{langMap[lang].share1}}: {{duration}}
      </p>
      <p>
        {{langMap[lang].share2}}: {{score}}
      </p>
      <p>
        {{rank}}
      </p>
    </div>
    <div class="blk3">
      <div class="btn btn-block" @click="_goUcenter">{{langMap[lang].share3}}</div>
    </div>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import answerHeader from './Header'
export default {
  name: 'Share',
  components: { answerHeader },
  computed: {
    ...mapState(['lang','langMap']),
  },
  data() {
    return {
      duration: this.$route.query.duration,
      score: this.$route.query.score,
      rank: this.$route.query.rank,
    }
  },
  created() {
  },
  methods: {
    _goUcenter() {
      this.$router.push('/login')
    },
  }
}

</script>
<style lang="scss">
@function rem($px) {
  @return $px/100+rem;
}

.blk2 {
  p {
    margin-top: rem(16);
  }
}

.blk3 {
  margin-top: rem(140);
}

.blk4 {
  margin-top: rem(74);
}

.sharePop {
  width: 100%;
  color: #000;
  padding: 20px 10px;
}

.share-item{
    display: inline-block;
    border: 1px #eee solid;
    margin: 5px;
    padding: .5em;
}

</style>



// WEBPACK FOOTER //
// src/components/Share.vue